import { render, staticRenderFns } from "./DataChoose.vue?vue&type=template&id=b3e1023c&scoped=true"
import script from "./DataChoose.vue?vue&type=script&lang=js"
export * from "./DataChoose.vue?vue&type=script&lang=js"
import style0 from "./DataChoose.vue?vue&type=style&index=0&id=b3e1023c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e1023c",
  null
  
)

export default component.exports